export default __webpack_public_path__ + "static/media/Megasol-Logo.b6d91025.png";